// extracted by mini-css-extract-plugin
module.exports = {"title":"Documents_title__2bpGS","selects":"Documents_selects__35VWN"};